// #####################################################

const useUsersSeoValidator = ({
	countryUrl,
	regionUrl,
	cityUrl,
	filterUrl,
}) => {
	const isLocationValid = () => {
		return countryUrl === "poland" && regionUrl && cityUrl;
	};

	const isFilterValid = () => {
		return (
			filterUrl === "women" ||
			filterUrl === "men" ||
			filterUrl === "couples" ||
			filterUrl === "transsexuals" ||
			filterUrl === "bdsm" ||
			filterUrl === "striptease" ||
			filterUrl === "swingers"
		);
	};

	// #####################################################

	return {
		isLocationValid,
		isFilterValid,
	};
};

// #####################################################

export default useUsersSeoValidator;

// #####################################################
